import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default (page) => {
    gsap.registerPlugin(ScrollTrigger);
    const main = document.querySelector('main');
    const basket = document.querySelector('.basket');
    const submenus = document.querySelectorAll("[data-submenu]");
    let offset
    window.innerWidth < 768?offset = 10:offset=100;
    
    page?pageOut():pageIn()

    function pageOut() {
		basket.classList.remove('active');
        gsap.to(main,
            {
                opacity: 0,
                duration: 0.35,
                ease: 'power1.Out'
            }
        )
       
        submenus.forEach( el =>{
            gsap.to(el, {
                height:0,
                duration: 0.5,
            })
        })
       
            
        
    }
    function pageIn() {
        gsap.to(main,
            {
                opacity: 1,
                duration: 0,
            }
        )
       
       
    }
}